module.exports = __webpack_public_path__ + "static/media/Lycanroc_gaussian2.a024e394.png";